import { memo } from 'react'
import cn from 'classnames'

import type { HStackProps } from './types'

import styles from '~/shared/ui/VStack/stack.module.scss'

/** Горизонтальная раскладка. Та же шкала отступов, что у `VStack`. */
export const HStack = memo(function HStack(props: HStackProps) {
  const {
    gap = 'MEDIUM_XS',
    align = 'CENTER',
    justify = 'START',
    wrap = false,
    isGrow = false,
    children,
  } = props

  return (
    <div
      className={cn(
        styles.root,
        styles.row,
        styles[`gap_${gap}`],
        styles[`align_${align}`],
        styles[`justify_${justify}`],
        wrap && styles.wrap,
        isGrow && styles.grow,
      )}
    >
      {children}
    </div>
  )
})
